import { storage } from '../services';

function getLocalLead() {
  const data = storage.getLead();
  return { success: !!data, data };
}

export default getLocalLead;
